import { Can } from 'providers/casl'

export const onGlobalSetupGoogleAdManagerConnectionAccess = (can: Can) => {
  can('access', 'GlobalSetupPage-googleAdManagerConnection')
}

export const onGlobalSetupGoogleAdManagerConnectionUpdate = (can: Can) => {
  can('update', 'GlobalSetupFeature-googleAdManagerConnection-connect')
  can('update', 'GlobalSetupFeature-googleAdManagerConnection-setupPrebidStack')
}

export const onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate = (can: Can) => {
  can('read', 'GlobalSetupFeature-googleAdManagerConnection-setupRetargetingDeliveryItems')
  can('update', 'GlobalSetupFeature-googleAdManagerConnection-setupRetargetingDeliveryItems')
}
